import React from 'react'

export const Footer = () => {
  return (
    <div className='text-white pt-0 md:mt-40 '>copyright@Neosky2023</div>
  )
}
